import apiClient from '../../../lib/axios';

export const fetchCountries= async ({ page = 1, pageSize = 10, isActive, search, CountryType } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  const { data } = await apiClient.get(`/api/locations/countries?${params.toString()}`);
  return data;
};

export const fetchCountryById = async (id) => {
  const { data } = await apiClient.get(`/api/locations/countries/${id}`);
  return data;
};

export const createCountry = async (payload) => {
  const { data } = await apiClient.post('/api/locations/countries', payload);
  return data;
};

export const updateCountry = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/locations/countries/${id}`, payload);
  return data;
};

export const deleteCountry = async (id) => {
  const { data } = await apiClient.delete(`/api/locations/countries/${id}`);
  return data;
};

export default fetchCountries;

